import React from 'react';
import './ListElement.css';

const ErrorListElement = ({ errorMessage, height = 50 }) => {
    return (
        <div className="list-element" style={{ 
            minHeight: height, 
            display: 'flex', 
            justifyContent: 'center', 
            alignItems: 'center',
            backgroundColor: '#8B0000',
            borderRadius: '4px'
        }}>
            <div style={{
                color: '#ffffff',
                textAlign: 'center',
                padding: '0 20px',
                fontWeight: '500'
            }}>
                {errorMessage}
            </div>
        </div>
    );
};

export default ErrorListElement; 